/**
 * @file select module
 * @author
 * title: string，名称
 * isMsgRequired: boolean，是否必填项
 * validCode：function，校验规则
 */
import React from 'react';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import LabelFormItem from '../LabelFormItem/index.tsx';
import {
    ExclamationCircleOutlined,
    DownOutlined
} from '@ant-design/icons';
import {Select} from 'antd';
import './index.less';

const {Option} = Select;

const SelectFormItem = (props) => {
    const {
        type,
        style,
        placeholder,
        title,
        isMsgRequired,
        data,
        updateData,
        phoneList,
        onChange,
        isSingle
    } = props;

    const handleChange = value => {
        updateData && updateData({
            [type]: value,
            [type + 'Err']: ''
        });
        onChange && onChange(value);
    };
    const setOption = () => {
        return phoneList.map((item) => {
            return (<Option key={item.phone} value={item.phone}>
                <div className="wrap-form-item">
                    <div className="form-item-phone">{item.phone}</div>
                    <div className="form-item-name">{item.name ? `${item.name}` : ''}</div>
                </div>
            </Option>);
        });
    };

    return (
        <div className={'form-item-select'}>
            {title && <LabelFormItem isMsgRequired={isMsgRequired} title={title} />}
            <div className={'form-item-select-box'}>
                <Select
                    className={
                        data[type + 'Err']
                            ? 'form-item-select-content border-error'
                            : 'form-item-select-content'
                    }
                    mode={isSingle ? '' : 'multiple'}
                    allowClear
                    // style={style}
                    placeholder={placeholder || '请选择'}
                    value={data[type]}
                    onChange={handleChange}
                >
                    {setOption()}
                </Select>
                <DownOutlined className="down-outlined" />
                {data[type + 'Err'] && <p className="form-item-select-err">
                    <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                    {data[type + 'Err']}</p>}
            </div>

        </div>
    );
};
SelectFormItem.propTypes = {
    type: PropTypes.string,
    title: PropTypes.string,
    isMsgRequired: PropTypes.bool,
    data: PropTypes.object,
    updateData: PropTypes.func,
    style: PropTypes.object,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    phoneList: PropTypes.array,
    isSingle: PropTypes.bool
};

export default withRouter(SelectFormItem);
